import React from "react";
import { Switch, Route } from "react-router-dom";

import Home from "../pages/Landing";
import SignUp from "../pages/SignUp";
import PaymentFeedback from "../pages/PaymentFeedback";

export default function Routes() {
  return (
    <Switch>
      <Route path="/" exact component={Home} />
      <Route path="/cadastro" exact component={SignUp} />
      <Route path="/pagamento-feedback/:status" exact component={PaymentFeedback} />
    </Switch>
  );
}
